import { render, staticRenderFns } from "./Role.vue?vue&type=template&id=2b60c3f2&scoped=true&"
import script from "./Role.vue?vue&type=script&lang=js&"
export * from "./Role.vue?vue&type=script&lang=js&"
import style0 from "./Role.vue?vue&type=style&index=0&id=2b60c3f2&lang=scss&scoped=true&"
import style1 from "./Role.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b60c3f2",
  null
  
)

export default component.exports